import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as CnLogo } from 'src/assets/images/logo/monotone_logo_nooklink_cn.svg';
import { ReactComponent as EnLogo } from 'src/assets/images/logo/monotone_logo_nooklink_en.svg';
import { ReactComponent as JaLogo } from 'src/assets/images/logo/monotone_logo_nooklink_ja.svg';
import { ReactComponent as KoLogo } from 'src/assets/images/logo/monotone_logo_nooklink_ko.svg';
import { ReactComponent as TwLogo } from 'src/assets/images/logo/monotone_logo_nooklink_tw.svg';

interface LogoMonotoneProps {
  scale?: number;
  color?: string;
}

export const LogoMonotone = ({ scale, color }: LogoMonotoneProps) => {
  const { i18n } = useTranslation();
  const { t } = useTranslation('translation');
  const s = scale ?? 1;
  const c = color || 'white';
  switch (i18n.language) {
    case 'ja-JP': {
      const width = 168 * s;
      const height = 40 * s;
      return <JaLogo role="img" aria-label={t('service_name')} fill={c} {...{ width, height }} />;
    }
    case 'zh-CN': {
      const width = 176 * s;
      const height = 40 * s;
      return <CnLogo role="img" aria-label={t('service_name')} fill={c} {...{ width, height }} />;
    }
    case 'zh-TW': {
      const width = 176 * s;
      const height = 40 * s;
      return <TwLogo role="img" aria-label={t('service_name')} fill={c} {...{ width, height }} />;
    }
    case 'ko-KR': {
      const width = 132 * s;
      const height = 40 * s;
      return <KoLogo role="img" aria-label={t('service_name')} fill={c} {...{ width, height }} />;
    }
    default: {
      const width = 164 * s;
      const height = 40 * s;
      return <EnLogo role="img" aria-label={t('service_name')} fill={c} {...{ width, height }} />;
    }
  }
};
